export default __webpack_public_path__ + "static/media/journeytray-redeemed-freedaypass.b2db6be2.svg";